import { DraftConfiguration, Size } from '@/types';
import { scaleSize } from './scaleSize';

export const getCurrentSizeOfConfiguration = (configuration: DraftConfiguration): Size =>
  scaleSize(configuration.size, configuration.scale);
